var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    fill: "#294562",
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analysis-report-document-develop-infromation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.71 13.29-11-11a1.033 1.033 0 0 0 -.71-.29h-25a3.009 3.009 0 0 0 -3 3v6.05a20.973 20.973 0 0 0 0 41.9v6.05a3.009 3.009 0 0 0 3 3h34a3.009 3.009 0 0 0 3-3v-45a1.033 1.033 0 0 0 -.29-.71zm-10.71-7.88 7.59 7.59h-6.59a1 1 0 0 1 -1-1zm-47 26.59a19.023 19.023 0 0 1 18-18.97v18.56l-13.1 13.1a18.879 18.879 0 0 1 -4.9-12.69zm6.31 14.1 13.1-13.1h18.56a18.963 18.963 0 0 1 -31.66 13.1zm49.69 12.9a1 1 0 0 1 -1 1h-34a1 1 0 0 1 -1-1v-6.05a21.014 21.014 0 0 0 20-20.95 1 1 0 0 0 -1-1h-19v-26a1 1 0 0 1 1-1h24v8a3.009 3.009 0 0 0 3 3h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 7a1 1 0 0 0 -1 1v20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1 21.023 21.023 0 0 0 -21-21zm1 20v-17.97a19.017 19.017 0 0 1 17.97 17.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49 40a9 9 0 1 0 9 9 9.014 9.014 0 0 0 -9-9zm0 16a7 7 0 1 1 7-7 7.008 7.008 0 0 1 -7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 50.586-2.293-2.293-1.414 1.414 3 3a1 1 0 0 0 1.414 0l6-6-1.414-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 19h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 25h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 31h8v2h-8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4a016b50e799a99dd33a674ab0529893.svg";
export { ForwardRef as ReactComponent };